import { useCallback } from "react";
import useRequest from "./useRequest";
import { API_PROFILE, BASE_API } from "../constants/api";
import { User, UserDBType } from "../types/user";
import { DateDataBaseType } from "../types/database";

type ProfileResponse = {
  user: Omit<User, 'active'> & DateDataBaseType & {
    id: number;
    accountActivateAt: string;
    status: string;
  }
}

type UpdateProfile = Pick<User, 'firstName' | 'lastName' | 'email'> & { password?: string };

const useProfile = () => {
  const {
    request: requestProfile,
    response: profileResponse
  } = useRequest<ProfileResponse>();

  const {
    response: updated,
    error: updateError,
    request: requestUpdate
  } = useRequest<{user: UserDBType}>();

  const getProfile = useCallback(() => {
    requestProfile(BASE_API, API_PROFILE, {secure: true});
  }, [requestProfile])

  const updateProfile = useCallback((user: UpdateProfile) => {
    requestUpdate(BASE_API, API_PROFILE, {method: 'PUT', secure: true}, {user});
  }, [requestUpdate])

  return {getProfile, profile: profileResponse?.user,
    updateProfile, updateSuccess: updated, updateError}
}

export default useProfile;